module.exports = __webpack_public_path__ + "static/media/view5_front.162379be.png";